
export default{
    accountNumber:'账号',
    home:'首页',
    ProjectSite:'项目现场',
    notice:'通知',
    UserRights:'用户权限',
    whole:'全部',
    onLine:'在线',
    offLine:'离线',
    serialNumber:'序列号',
    GatewayName:'网关名称',
    PleaseinputGatewayName:'请输入网关名称',
    PleaseinputserialNumber:'请输入序列号',
    newlyAdded:'新增',
    Import:'导入',
    export:'导出',
    DisplayColumns:'显示列',
    Submit:'提交',
    AlarmEvent:'告警事件',
    systemLog:'系统日志',
    Unread:'未读',
    Read:'已读'
};